import ListLabel from './ListLabel'

export default ListLabel
